import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=7f65319f"
import script from "./TheAlert.vue?vue&type=script&lang=ts"
export * from "./TheAlert.vue?vue&type=script&lang=ts"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=7f65319f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports